// extracted by mini-css-extract-plugin
export var move = "styles-module__move___MT3CF";